var r=Object.prototype.hasOwnProperty;var t=function(t,a){return null!=t&&r.call(t,a)};export{t as default};
//# sourceMappingURL=_baseHas.js.map
